import {
  type DisplayPrice,
  type HeadlinePriceComponents,
} from '@/modules/price/aliases';

export type HeadlineDescriptionKey =
  'InclFeesAndShipping' | 'InclMarketplaceFee';

export function shouldShowPriceBreakdown(displayPrice: DisplayPrice): boolean {
  const { buyer_fee, shipping_price } =
    displayPrice.headline_price_components ?? {};

  return Boolean(buyer_fee || shipping_price) && !displayPrice.secondary_price;
}

export function getHeadlineDescriptionKey(
  components?: HeadlinePriceComponents
): HeadlineDescriptionKey | undefined {
  const { buyer_fee, shipping_price } = components ?? {};

  if (buyer_fee && shipping_price) {
    return 'InclFeesAndShipping';
  }

  if (buyer_fee && !shipping_price) {
    return 'InclMarketplaceFee';
  }

  return undefined;
}
